import { render, staticRenderFns } from "./DepositWithdraw.vue?vue&type=template&id=97f28466&scoped=true&"
import script from "./DepositWithdraw.vue?vue&type=script&lang=ts&"
export * from "./DepositWithdraw.vue?vue&type=script&lang=ts&"
import style0 from "./DepositWithdraw.vue?vue&type=style&index=0&id=97f28466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f28466",
  null
  
)

export default component.exports